import { render, staticRenderFns } from "./FeeImportAds.vue?vue&type=template&id=2cebf00d&scoped=true&"
import script from "./FeeImportAds.vue?vue&type=script&lang=js&"
export * from "./FeeImportAds.vue?vue&type=script&lang=js&"
import style0 from "./FeeImportAds.vue?vue&type=style&index=0&id=2cebf00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebf00d",
  null
  
)

export default component.exports